import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';

import { toggleSearchInput as toggleSearchInputAction } from '../../../actions';
import { OutlinedButton } from '@prisjakt/ui/button/variants';

type OwnProps = {
  className?: string;
};

type DispatchProps = {
  toggleSearchInput: () => void;
};

type Props = OwnProps & DispatchProps;

const ToggleSearchButton = ({ className, toggleSearchInput }: Props) => {
  const { t } = useContext(AppContext);
  return (
    <OutlinedButton className={className} onClick={toggleSearchInput}>
      {t('common', 'button.add')}
    </OutlinedButton>
  );
};

const dispatchProps = {
  toggleSearchInput: toggleSearchInputAction,
};

export default connect(null, dispatchProps)(ToggleSearchButton);
